// @ts-nocheck
export const CHECKBOX_CELL_WIDTH = '12rem'
export const CLOSE_CELL_WIDTH = '3rem'
